import { render, staticRenderFns } from "./editFromRate.vue?vue&type=template&id=5b4491f2"
import script from "./editFromRate.vue?vue&type=script&lang=js"
export * from "./editFromRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports